import { a as __makeTemplateObject, c as __rest, _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import styled, { withTheme } from 'styled-components';
import { a as largeQuery } from './breakpoints-70e05b67.js';

var theme = {
    bottomBackgroundColor: '#fff',
    bottomBackgroundMuted: 'rgba(0, 0, 0, 0.05)',
    bottomForegroundActionPrimary: '#CC1F42',
    bottomForegroundActionSecondary: '#fff',
    bottomForegroundDanger: '#d0021b',
    bottomForegroundPrimary: '#4a4a4a',
    bottomForegroundSecondary: '#9b9b9b',
    bottomForegroundWarning: '#f47920',
    calendarDaySelectedBackgroundColor: '#1C6BAE',
    calendarDaySelectedColor: '#fff',
    checkboxCheckStrokeColor: '#CC1F42',
    contextBubbleBackgroundColor: '#CC1F42',
    contextBubbleBorderColor: '#fff',
    contextBubbleDangerBackgroundColor: '#d0021b',
    contextBubbleEmergencyHoursBackgroundColor: '#CC1F42',
    contextBubbleForegroundColor: '#fff',
    contextBubbleInvertBackgroundColor: '#fff',
    contextBubbleInvertBorderColor: '#CC1F42',
    contextBubbleInvertForegroundColor: '#CC1F42',
    curtainBackgroundColor: 'rgba(255, 255, 255, 0.95)',
    fontFamilyPrimary: 'proxima-nova, sans-serif',
    homeButtonTopBackgroundColor: '#1C6BAE',
    infoTooltipStrokeColor: '#CC1F42',
    inputBorderColorDefault: '#808080',
    inputBorderColorError: '#d0021b',
    inputBorderColorFocus: '#17497b',
    inputBorderColorWarning: '#f47920',
    mapBadgeBackgroundColor: '#CC1F42',
    mapBadgeBorderColor: '#CC1F42',
    mapPinFillColor: '#1C6BAE',
    mediaUploadActionItemColor: '#1C6BAE',
    navSelectedBackground: '#1C6BAE',
    pillBoxForegroundColor: '#1C6BAE',
    pillBoxSelectedBackgroundColor: '#1C6BAE',
    pillBoxSelectedForegroundColor: '#fff',
    roomButtonFillColor: '#1C6BAE',
    svgFillDisabled: '#d7d7d7',
    svgStrokeDefault: '#979797',
    topBackgroundColor: '#CC1F42',
    topBackgroundGradient: 'radial-gradient(ellipse 100% 65.5% at 100% center, #CC1F42)',
    topBackgroundGradientExpanded: 'radial-gradient(ellipse 70% 95% at 85% 100%, #CC1F42)',
    topBackgroundGradientStop1: '',
    topBackgroundGradientStop2: '#CC1F42',
    topForegroundMuted: 'rgba(255, 255, 255, 0.4)',
    topForegroundPrimary: '#fff',
    topForegroundSecondary: '#1C6BAE',
    topSvgFill: 'rgba(255, 255, 255, 0)',
    topSvgFillActive: 'rgba(255, 255, 255, 0.2)',
    topSvgFillHover: 'rgba(255, 255, 255, 0.1)',
    transitionDurationCarouselTrack: '600ms',
    transitionDurationPrimary: '250ms',
};

var Badge = styled.span(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  align-items: center;\n  border-radius: 100%;\n  display: flex;\n  height: 23px;\n  justify-content: center;\n  letter-spacing: 0;\n  position: absolute;\n  right: -7px;\n  text-align: center;\n  text-transform: uppercase;\n  top: 0;\n  width: 23px;\n\n  ", "\n"], ["\n  align-items: center;\n  border-radius: 100%;\n  display: flex;\n  height: 23px;\n  justify-content: center;\n  letter-spacing: 0;\n  position: absolute;\n  right: -7px;\n  text-align: center;\n  text-transform: uppercase;\n  top: 0;\n  width: 23px;\n\n  ", "\n"])), function (_a) {
    var themeValues = _a.themeValues;
    return "\n      background: " + themeValues.backgroundColor + ";\n      border: 1px solid " + themeValues.borderColor + ";\n      color: " + themeValues.borderColor + ";\n      font: 800 13px/16px " + themeValues.fontFamily + ";\n    ";
});
Badge.displayName = 'Badge';
var templateObject_1$3;

var Circle = styled.span(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  align-items: center;\n  border-radius: 100%;\n  display: flex;\n  justify-content: center;\n  position: relative;\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  align-items: center;\n  border-radius: 100%;\n  display: flex;\n  justify-content: center;\n  position: relative;\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_a) {
    var themeValues = _a.themeValues;
    return "\n    background-color: " + themeValues.backgroundColor + ";\n    border: 1px solid " + themeValues.borderColor + ";\n    transition: background-color " + themeValues.transitionDuration + " ease;\n\n    [data-svg-class='Icon-fill'] {\n      fill: " + themeValues.backgroundColor + ";\n      transition: fill " + themeValues.transitionDuration + " ease;\n    }\n\n    [data-svg-class='Icon-stroke'] {\n      stroke: " + themeValues.borderColor + ";\n      transition: stroke " + themeValues.transitionDuration + " ease;\n    }\n  ";
}, function (_a) {
    var hasShadow = _a.hasShadow;
    if (hasShadow) {
        return "\n        box-shadow: 1px 2px 14px rgba(0, 0, 0, 0.5);\n      ";
    }
}, function (_a) {
    var size = _a.size;
    switch (size) {
        case 'small':
            return "\n          height: 36px;\n          width: 36px;\n        ";
        case 'medium':
            return "\n          height: 40px;\n          width: 40px;\n        ";
        case 'large':
            return "\n          height: 54px;\n          width: 54px;\n        ";
    }
});
Circle.displayName = 'Circle';
var templateObject_1$2;

var Button = styled.button(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  align-items: center;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  display: flex;\n  flex-direction: ", ";\n  justify-content: flex-start;\n  line-height: 1;\n  padding: 0;\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.4;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  align-items: center;\n  background-color: transparent;\n  border: 0;\n  cursor: pointer;\n  display: flex;\n  flex-direction: ", ";\n  justify-content: flex-start;\n  line-height: 1;\n  padding: 0;\n\n  &:disabled {\n    cursor: default;\n    opacity: 0.4;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n"])), function (props) {
    return props.labelAlign === 'bottom' ? 'column' : 'row';
}, function (_a) {
    var labelAlign = _a.labelAlign;
    return "\n    flex-direction: " + (labelAlign === 'bottom' ? 'column' : 'row') + ";\n  ";
}, function (_a) {
    var themeValues = _a.themeValues;
    return "\n    transition: opacity " + themeValues.transitionDuration + " ease;\n  ";
}, function (_a) {
    var disabled = _a.disabled, isChecked = _a.isChecked, isHoverAnimated = _a.isHoverAnimated, themeValues = _a.themeValues;
    var circleFilledStyles = "\n      > " + Circle + " {\n        background-color: " + themeValues.borderColor + ";\n\n        [data-svg-class=\"Icon-fill\"] {\n          fill: " + themeValues.borderColor + ";\n        }\n\n        [data-svg-class=\"Icon-stroke\"] {\n          stroke: " + themeValues.backgroundColor + ";\n        }\n      }\n    ";
    var isCheckbox = typeof isChecked !== 'undefined';
    if (isCheckbox) {
        return isChecked === true ? circleFilledStyles : '';
    }
    if (isHoverAnimated && !disabled) {
        // We only want our hover styles to show up on large views because they
        // don't act correctly on mobile
        return "\n        @media " + themeValues.mediaLarge + " {\n          &:hover {\n            " + circleFilledStyles + "\n          }\n        }\n      ";
    }
});
Button.displayName = 'Button';
var templateObject_1$1;

var Label = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n\n  ", "\n\n  ", "\n"], ["\n  color: ", ";\n\n  ", "\n\n  ", "\n"])), function (props) { return props.themeValues.labelColor; }, function (_a) {
    var labelStyle = _a.labelStyle, themeValues = _a.themeValues;
    switch (labelStyle) {
        case 'title':
            return "\n          font: 13px " + themeValues.fontFamily + ";\n        ";
        case 'eyebrow-thin':
            return "\n          font: 15px/18px " + themeValues.fontFamily + ";\n          text-transform: uppercase;\n        ";
        case 'eyebrow':
            return "\n          font: 800 13px/16px " + themeValues.fontFamily + ";\n          letter-spacing: 2px;\n          text-transform: uppercase;\n        ";
    }
}, function (_a) {
    var labelAlign = _a.labelAlign;
    switch (labelAlign) {
        case 'bottom':
            return "\n          padding-top: 8px;\n          text-align: center;\n        ";
        case 'right':
            return "\n          padding-left: 8px;\n        ";
    }
});
Label.displayName = 'Label';
var templateObject_1;

var circleButtonDefaultThemeValues = {
    backgroundColor: '#fff',
    borderColor: '#4C6B9A',
    fontFamily: 'proxima-nova, sans-serif',
    labelColor: '#4C6B9A',
    mediaLarge: '(min-width: 768px)',
    transitionDuration: '250ms',
};
/**
 * A button that has a circle which wraps an SVG icon, and has an accompanying
 * label.
 */
var CircleButton = function (props) {
    var badge = props.badge, className = props.className, icon = props.icon, _a = props.hasShadow, hasShadow = _a === void 0 ? false : _a, isChecked = props.isChecked, _b = props.isDisabled, isDisabled = _b === void 0 ? false : _b, _c = props.isHoverAnimated, isHoverAnimated = _c === void 0 ? true : _c, label = props.label, _d = props.labelAlign, labelAlign = _d === void 0 ? 'right' : _d, onClick = props.onClick, _e = props.size, size = _e === void 0 ? 'medium' : _e, _f = props.themeValues, themeValuesFromProps = _f === void 0 ? {} : _f;
    var labelStyle = props.labelStyle;
    if (!labelStyle) {
        switch (size) {
            case 'small':
                labelStyle = 'title';
                break;
            case 'medium':
                labelStyle = 'eyebrow-thin';
                break;
            case 'large':
                labelStyle = 'eyebrow';
                break;
        }
    }
    var themeValues = __assign(__assign({}, circleButtonDefaultThemeValues), themeValuesFromProps);
    return (jsxs(Button, __assign({ className: className, disabled: isDisabled, isChecked: isChecked, isHoverAnimated: isHoverAnimated, labelAlign: labelAlign, onClick: onClick, themeValues: themeValues, type: "button" }, { children: [jsxs(Circle, __assign({ hasShadow: hasShadow, size: size, themeValues: themeValues }, { children: [badge && jsx(Badge, __assign({ themeValues: themeValues }, { children: badge }), void 0), icon] }), void 0), label && (jsx(Label, __assign({ labelAlign: labelAlign, labelStyle: labelStyle, themeValues: themeValues }, { children: label }), void 0))] }), void 0));
};
var ThemedCircleButton = withTheme(function (_a) {
    var props = __rest(_a, []);
    return (jsx(CircleButton, __assign({}, props, { themeValues: {
            backgroundColor: theme.bottomBackgroundColor,
            borderColor: theme.bottomForegroundActionPrimary,
            fontFamily: theme.fontFamilyPrimary,
            labelColor: theme.bottomForegroundActionPrimary,
            mediaLarge: largeQuery,
            transitionDuration: theme.transitionDurationPrimary,
        } }), void 0));
});

export { CircleButton as C, ThemedCircleButton as T, circleButtonDefaultThemeValues as c };
